class HHGalleryZoom extends HTMLElement {
  constructor() {
    super()

    this.triggers = this.querySelectorAll('.js-media-zoom')
    this.mainCarousel = this.querySelector('.js-product-media-main')
    this.handleClick = this.handleClick.bind(this)
    this.handleMediaSlideChange = this.handleMediaSlideChange.bind(this)
  }

  connectedCallback() {
    this.triggers.forEach((el) => {
      el.addEventListener('click', this.handleClick)
    })
    this.mainCarousel?.addEventListener('mediaSlideChange', this.handleMediaSlideChange)
  }

  disconnectedCallback() {
    this.triggers.forEach((el) => {
      el.removeEventListener('click', this.handleClick)
    })
    this.mainCarousel?.removeEventListener('mediaSlideChange', this.handleMediaSlideChange)
  }

  handleMediaSlideChange(e) {
    const isModelSlide = e?.detail?.mediaType === 'model'

    this.querySelectorAll('[data-disable-on-model="true"]').forEach((trigger) => {
      trigger.classList.toggle('zoom-button--disabled', isModelSlide)
      if (isModelSlide) {
        trigger.setAttribute('aria-disabled', 'true')
      } else {
        trigger.removeAttribute('aria-disabled')
      }
    })
  }

  handleClick(e) {
    if (e.currentTarget.getAttribute('aria-disabled') === 'true') return

    const index =
      e.currentTarget.dataset.index ??
      document.querySelector('.js-product-media-main').current

    e.currentTarget.dispatchEvent(
      new CustomEvent('openDrawer', {
        bubbles: true,
        composed: true,
        detail: {
          key: 'media-zoom',
          event: e,
          index: index,
        },
      })
    )
  }
}

customElements.define('hh-gallery-zoom', HHGalleryZoom)
